var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHomeThin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04511 1L1.01224 9.24289C0.984187 9.27575 1.00743 9.32705 1.05072 9.32705H3.75613V17H7.12607V12.2657H10.9633V17H14.3341V9.32705H17.0395C17.0828 9.32705 17.106 9.27575 17.0772 9.24289L9.04511 1Z",
    stroke: "#383E41"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeThin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HomeThin.bd0769a2.svg";
export { ForwardRef as ReactComponent };